// extracted by mini-css-extract-plugin
module.exports = {"buttonsPagination":"Pagination_buttonsPagination__37HOl","active":"Pagination_active__1R0gI","button_Next_Prev":"Pagination_button_Next_Prev__30uyX"};